import React, { useState, useEffect } from 'react';
import { viewPackage, deletePackage } from "../../../ReduxStore/Slice/Pricing/PackageSlice";
import { useDispatch } from 'react-redux';
import Datatable from '../../../ExtraComponents/ReusableTable2';
import { useNavigate } from 'react-router-dom';
import { PenLine, Trash2 } from 'lucide-react';
import sweatalert from "sweetalert2";
import ReactPaginate from "react-paginate";
import { Link } from 'react-router-dom';



const Service = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const [getPackageData, setPackageData] = useState([]);
  const [InputValue, setInputValue] = useState('');



  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };


  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])


  useEffect(() => {
    getAllPackage();;
  }, [currentPage, pageSize, InputValue]);



  const getAllPackage = async () => {
    setLoading(true);

    const req = {
      agent_id: agent_id,
      page: currentPage,
      limit: pageSize,
      search: InputValue
    };

    try {
      const response = await dispatch(viewPackage(req)).unwrap();
      if (response.status) {
        setPackageData(response.data);
        setTotalRecords(response?.pagination?.total || 0);
      } else {
        setPackageData([]);
      }
    } catch (error) {
      console.error("Error fetching package data:", error);
      setPackageData([]);
    } finally {
      setLoading(false);
    }
  };


  const deletePackageRow = async (row) => {
    sweatalert.fire({
      title: "Are you sure?",
      text: "You want to delete this package! ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id, agent_id: agent_id };
        await dispatch(deletePackage(req)).unwrap()
          .then((response) => {
            if (response.status) {
              sweatalert.fire({
                title: "Success",
                text: "Package Deleted Successfully",
                icon: "success",
                timer: 7000,
                timerProgressBar: true
              }
              );
              getAllPackage()
            }
          })
          .catch((error) => {
            console.error("Error deleting package:", error);
          });
      } else if (result.dismiss === sweatalert.DismissReason.cancel) {
        return
      }
    });

  }

  const columns = [

    {
      name: "Package Name",
      cell: (row) => (
        <a
          href={`#/admin/pricing/view-package?id=${row.id}`}
          className="text-pink font-bold"
          style={{
            fontWeight: "bold",

          }}
          onClick={(e) => {
            if (!(e.ctrlKey || e.metaKey || e.button === 1)) {
              e.preventDefault();
              navigate("/admin/pricing/view-package", {
                state: { row },
              });
            }
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {row.name}
        </a>
      ),
       selector: (row) => row.name,
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => Number(row.status) === 1 ? "Active" : "Inactive",
      selector: (row) => row.status,
      sortable: true,
      width: "150px",
    },

    {
      name: "Applicable",
      selector: (row) =>
        row.applicable.split(',').map(item => item.trim())
          .map((item) => <div className='applicable-data'>{item}</div>)
      ,
      sortable: true,
      width: "150px",
    },
    {
      name: (
        <div>
          Total Cost of Service
        </div>
      ),
      selector: (row) => row.cost_service_price,
      sortable: true,
      width: "190px",
    },
    {
      name: (
        <div>
          Default  Price
        </div>
      ),
      selector: (row) => {
        const price = Number(row.default_price);
        return Number.isInteger(price) ? price : price.toFixed(2);
      },
      sortable: true,
      width: "150px",
    },
    {

      name: (
        <div>
          Default Discount
        </div>
      ),
      selector: (row) => {
        const discount = Number(row.default_discount);
        return Number.isInteger(discount) ? discount : discount.toFixed(2);
      },
      sortable: true,
      width: "170px",
    },
    {
      name: (
        <div>
          Minimum Price
        </div>
      ),

      selector: (row) => {
        const price = Number(row.min_price);
        return Number.isInteger(price) ? price : price.toFixed(2);
      },
      sortable: true,
      width: "150px",
    },
    {


      name: (
        <div>Maximum Discount</div>
      ),
      selector: (row) => {
        const discount = Number(row.max_discount);
        return Number.isInteger(discount) ? discount : discount.toFixed(2);
      },
      sortable: true,
    },

    // {
    //   name: (
    //     <div>
    //       Qualifying Conditions
    //     </div>
    //   ),
    //   selector: (row) => Number(row.qualifying_condition) === 1 ? "Active" : "Inactive",
    //   sortable: true,
    // },
    {
      name: "Action",
      selector: (row) => <>
        <div className='d-flex justify-content-start' style={{ width: "150px" }}>

          <PenLine
            onClick={() =>
              navigate('/admin/pricing/edit-package', { state: { row: row }, })
            }
          />
          {
            row?.deleted && <Trash2 onClick={() => deletePackageRow(row)} />
          }
        </div>
      </>,
      sortable: true,
    },
  ];

  return (
    <div>
      <section className="section dashboard">

        <div className="row">
          <h4 className="page-title">
            <button className="btn p-0 fs-5" onClick={() => navigate('/admin/pricing/package')}>
              <i className="bx bx-arrow-back text-pink pe-1"></i>
            </button>

            All Packages
          </h4>


          <div className='  package-table'>
            <div className="row">
              <data className="col-lg-3 datatable-search mb-2">
                <input
                  type="text"
                  className="search p-2 icon"
                  placeholder="Search here"
                  value={InputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                />
              </data>
              <div></div>
            </div>

            <div>
              <Datatable
                columns={columns}
                data={getPackageData}
                filter={false}
                loading={loading}
              />
              {getPackageData.length > 0 ? <div>
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />

                <div className="mt-0">

                  <select className="perpage-select" value={pageSize} onChange={handlePageSizeChange}>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                    <option value={0}>{"ALL"}</option>


                  </select>
                </div>
              </div> : ""}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Service;
